// On product page get currently selected variant
g_getSelectedVariant = function() {
  if (!window.g_product) return

  const picker = document.querySelector('variant-picker');
  const variant = picker?.selectedVariant;
  return variant?.title;
}

/*
____________________________
 
  VALIDATOR
____________________________
 
*/

//
// Error Class
// _________________

class ValidatorError {
	
	$h = $([])
    handle = ''
    hideMsgOnSuccess = true
    classesToRemoveOnSuccess = 'error-flag'
    afterSuccess = null
    errorMsg = ''
    showMsgOnError = true
    classesToAddOnError = 'error-flag'
    disableSubmit = true
    afterError = null
	
	constructor(config) {
        for (let key in config)
          this[key] = config[key]
	}

	isValid(input) {
		return this.isValid(input)
	}

	onSuccess(field) {
		if (this.hideMsgOnSuccess)
			this.$h.slideUp()

		if (this.afterSuccess)
			this.afterSuccess(field, this)
	}

	onError(field) {
		if (this.showMsgOnError)
            this.$h.slideDown()

		if (this.afterError)
			this.afterError(field, this)
	}
}

//
// Field Class
// _____________________

class ValidatorField {

	$h = $([])
	errors = []

	constructor(config) {
		this.errors = config.errors
		if (config.$h) this.$h = config.$h
    }

	getInput() {
		return this.$h.val()
	}

	// Returns a list of errors
    //
	validate(inputVal) {
      let errorList = []
      let successList = []

      for (let error of this.errors) {
        
          let input = inputVal || this.getInput()
        
          if (error.isValid(input)) {
              error.onSuccess(this)
              successList.push(error)
          }
          else {
              error.onError(this)
              errorList.push(error)
          }
      }

      this.addRemoveClasses(errorList, successList)
    
      return errorList
	}

    addRemoveClasses(errorList, successList) {
      let toAdd = []
      let toRemove = []
      
      for (let error of successList)
        toRemove.push(error.classesToRemoveOnSuccess)

      for (let error of errorList)
        toAdd.push(error.classesToAddOnError)

      this.$h
        .removeClass(toRemove.join(' '))
        .addClass(toAdd.join(' '))
    }
  
}